module.exports = __webpack_public_path__ + "img/13-traffic-pattern.98d295f4.jpg";